import { render, staticRenderFns } from "./PidueciActivityPage.vue?vue&type=template&id=04e16320&"
import script from "./PidueciActivityPage.vue?vue&type=script&lang=js&"
export * from "./PidueciActivityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports